import { render } from "./PoliticaCamasLibres.vue?vue&type=template&id=5c6e5f08&scoped=true"
import script from "./PoliticaCamasLibres.vue?vue&type=script&lang=js"
export * from "./PoliticaCamasLibres.vue?vue&type=script&lang=js"

import "./PoliticaCamasLibres.vue?vue&type=style&index=0&id=5c6e5f08&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6e5f08"]])

export default __exports__